<template>
  <div>
    <el-tag
      style="margin-left: 0.1rem"
      v-if="server.isMultiple"
      v-for="(tags, index) in server.dynamicTags"
      :key="tags.id"
      closable
      @close="emitCloseTag(tags, server.selectList, cid, server.role, server.selectRef)"
      :disable-transitions="false"
    >
      {{ tags.username }}
    </el-tag>

    <el-tag
      v-else
      v-for="(tag, index) in server.dynamicTags"
      :key="tag.username + '-' + index"
      :disable-transitions="false"
    >
    {{ tag.username }}
    </el-tag>

    <el-select
      v-if="server.isShow"
      v-model="server.selectList"
      value-key="value"
      :ref="server.selectRef"
      :multiple="server.isMultiple"
      placeholder="请选择"
      filterable
      clearable
      style="width: 100%"
      size="mini"
      @change="emitChange($event, cid, server.role, server.selectRef)"
    >
      <el-option
        v-for="item in userList"
        :key="item.id"
        :label="item.username"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <el-button
      v-else
      class="button-new-tag"
      @click="emitClick($event, server.role, server.selectRef)"
      size="small"
      >{{ server.isMultiple === true ? "新增" : "修改" }}</el-button
    >
  </div>
</template>

<script>
export default {
  name: "CompanySingleServer",
  props: {
    singleServer: {
        type: Object,
        default: null,
        required: false
    },
    cid: {
        type: Number,
        default: 0,
        required: false,
    },
    userList: Array
  },
  watch: {
    cid: {
      handler(newVal) {
        if (newVal) {
          this.company_id = newVal;
        }
      },
      immediate: true,
    },
    singleServer: {
      handler(newVal) {
        if (newVal) {
          this.server = newVal;
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {},
  data() {
    return {
        company_id: null,
        server: {},  // 单个服务人员
        // userList: [],
    };
  },
  methods: {
    emitCloseTag(tag, selectList, cid, role, selectRef) {
      this.$emit('tagClosed', tag, selectList, cid, role, selectRef);
    },
    emitChange(value, cid, role, selectRef) {
      this.$emit('selectChanged', value, cid, role, selectRef);
    },
    emitClick(value, role, selectRef) {
      this.$emit('selectClick', value, role, selectRef);
    }
  },
  mounted() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/CompanySingleServer.vue